export const certificationEn = {
  certification: {
    badge: "Standards & Methodologies",
    title: "Open Standards & Methodologies",
    subtitle: "Sentinel Crop implements public international standards for precision agriculture. We do not hold third-party certifications today — we describe what is implemented, not what is certified.",
    iso: {
      title: "ISO 11783 Data Compatibility",
      badge: "Self-declared",
      description: "Self-declared technical compatibility with the ISOXML v4.3 data structure described in ISO 11783-10:2015. Sentinel Crop has not been audited by AEF or any other third party — this is not a certificate.",
      feature1: "ISOXML v4.3 export format",
      feature2: "Variable rate prescription maps",
      feature3: "WGS84 coordinate system",
      disclaimer: "Self-declaration of technical compatibility — not an externally issued certificate, not endorsed by AEF, AENOR or any third-party body.",
      viewDeclaration: "View Declaration"
    },
    fao: {
      title: "FAO-56 Methodology Implemented",
      badgeSingle: "Single Kc",
      badgeDual: "Dual Kc (Beta)",
      description: "Implementation of the public FAO-56 Penman-Monteith methodology (Allen et al., 1998). FAO-56 is an open scientific methodology — the FAO does not certify software, and Sentinel Crop is not endorsed by the FAO.",
      feature1: "Single Kc: Implemented",
      feature2: "Dual Kc (Kcb + Ke): Implemented (Beta)",
      feature3: "Internal algorithmic-coherence checks vs reference weather services",
      status: "Status",
      statusValue: "Open methodology — internal implementation. Not peer-reviewed, not externally certified.",
      coverage: "Geographic scope",
      coverageValue: "Europe, Latin America, Worldwide",
      viewMethodology: "View Methodology"
    },
    trust: {
      description: "We document what is implemented, what is in beta, and what is not yet validated. We do not claim third-party certifications we don't hold.",
      internationalStandard: "International Standard",
      globalWeatherPartners: "Global Weather Data Sources",
      methodologyTransparency: "Methodology Transparency"
    }
  },
  testimonials: {
    badge: "What professionals say",
    title: "Field-Tested by Agronomists",
    subtitle: "Two real, anonymised quotes from professionals who evaluated Sentinel Crop. Names of institutions and companies are omitted at the reviewers' request.",
    review1: {
      quote: "A technically robust solution — particularly valuable for cooperative technicians managing multiple farms. The centralized workspace approach is the right market strategy.",
      role: "Senior Agronomist",
      context: "Public agricultural research centre (Spain)"
    },
    review2: {
      quote: "The satellite monitoring data and irrigation recommendations provide valuable information that helps make more informed decisions about crop management",
      role: "Technical Advisor",
      context: "Andalusian olive-oil cooperative"
    },
    expertBadge: "Early expert feedback",
    expertTitle: "Early expert feedback",
    expertSubtitle: "Feedback from agronomy, insurance and agricultural technology professionals reviewing Sentinel Crop's approach to parcel intelligence, risk detection and evidence-backed decisions.",
    expert1: {
      quote: "Sentinel Crop feels ahead of the curve compared with other agricultural intelligence platforms I have seen.",
      role: "Senior executive",
      context: "Agricultural insurance sector — United States"
    },
    expert2: {
      quote: "A robust platform that can reduce decision time while grounding recommendations in verifiable scientific evidence.",
      role: "Agribusiness / insurance executive",
      context: "Early reviewer"
    },
    expert3: {
      quote: "A tool that can clearly help the next generation of agronomists make better field decisions.",
      role: "University Professor, Agronomy",
      context: "Early reviewer"
    }
  }
};
